const ReportTypes = [
  { name: "آمار", value: "statistic", type: "statistic" },
  { name: "نمودار خطی", value: "gutter" },
  { name: "ترافیک", value: "net", type: "img" },
  { name: "پردازش", value: "cpu", type: "img" },
  { name: "وقفه", value: "irq", type: "img" },
  { name: "حافظه", value: "ram", type: "img" },
  { name: "دیسک", value: "disk", type: "img" },
  { name: "پای‌چارت", value: "gutter" },
  { name: "دیسک", value: "disk_pie", type: "chart" },
  { name: "کش", value: "cache", type: "chart" },
];
export default ReportTypes;